import React from "react";
import { useSelector } from "react-redux";
import pathRouts from "../../../../shared/enums/pathRoute";
import useMyLearningNmm from "../../../../shared/components/pages/myLearningPage/useMyLearningNmm";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import Widget from "../../../../shared/components/features/widget/Widget";
import WidgetNmmCard from "../../../features/widgetNmmCard/WidgetNmmCard";
import classes from './MyLearningWidget.module.css';

const MyLearningWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const nmms = useMyLearningNmm();

    return (
        <Widget
            color="#FDDB71"
            mainLink={`/${pathRouts.MYLEARNING}`}
            title={texts.myClasses}
            icon={iconsList.myLearning}
            className={classes.MyLearningWidget}
        >
            <div className={classes.DomainsList}>
                {nmms?.map((sg, index) =>
                    <WidgetNmmCard key={index} StudyGroup={sg} />
                )}
            </div>
        </Widget>
    );
};

export default MyLearningWidget;
